// Components
import ProductLargeSingle from '@/components/product-large-single/component'
import Usps from '@/components/usps/component'
import Inspiration from '@/components/inspiration/component'
import OurArtists from '@/components/our-artists/component'
import CustomerQuotes from '@/components/customer-quotes/component'
import Instagram from '@/components/instagram/component'
import TextComponent from '@/components/text/component'
import PosterCustomization from '@/components/poster-customization/component'

export default {
  name: 'index-page',
  components: {
    ProductLargeSingle,
    Usps,
    Inspiration,
    OurArtists,
    CustomerQuotes,
    Instagram,
    TextComponent,
    PosterCustomization
  }
}



// WEBPACK FOOTER //
// ./src/pages/index/script.js